// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:22
import { ResAddress_abstract } from './../abstract/SagaSchema/ResAddress_abstract';
export class ResAddress extends ResAddress_abstract {}
